import React, { useEffect, useState } from 'react';
import CustomSelect from "../../../components/UI/customSelect/customSelect";
import { Get, Post } from "../../../apis/api";
import LoadingFix from "../../../components/loading-fix/loading-fix";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import CustomButton from "../../../components/UI/customButton/customButton";
import { useTranslation } from "react-i18next";
import { useVisaRegister } from './zustand';
import { useQuery } from 'react-query';
import CustomInput from '../../../components/UI/customInput/customInput';
import { InputField } from '../../../components/UI/InputField/InputField';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import clsx from 'clsx';
import moment from 'moment-jalaali';


const WharfStep = ({ changeStep, activeStep }) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [dataShip, setDataShip] = useState([])
  const [dataDock, setDataDock] = useState([])
  const [form, setForm] = useState({});
  const { t } = useTranslation()

  const { back, forward, selectedVisa, record } = useVisaRegister()

  console.log({ record })


  const handleForm = ({ name, value }) => {
    setForm((prevState) => ({ ...prevState, [name]: value }));
  };
  useEffect(() => {
    if (activeStep)
      handleList()
  }, [activeStep])

  const { data: dockAllData, isLoading } = useQuery({
    queryFn: () => Get('/basic-information/dock'),
    queryKey: ['GetDocks']
  })

  const dockData = dockAllData?.details?.data?.data


  const { data: airportAllData, isLoading: loadingAirport } = useQuery({
    queryFn: () => Get('basic-information/airport?page=1&per_page=100'),
    queryKey: ['Get-Airports']
  })

  const dataAirport = airportAllData?.details?.data?.data

  const handleList = () => {
    setLoading(true)
    Get(`agent/profile/docks`).then((res) => {
      setData(res?.details)
    }).finally(() => {
      setLoading(false)
    })
  }

  const handleSubmit = () => {
    if (selectedVisa?.need_exit_dock && !form?.destination_dock_id) {
      return toast.error(t('DistDockIsRequired'))
    }
    if (selectedVisa?.need_exit_dock && !form?.exit_airport) {
      return toast.error(t('ExitAirportIsRequired'))
    }
    if (selectedVisa?.need_exit_dock && !form?.exit_date) {
      return toast.error(t('ExitDateIsRequired'))
    }
    setLoading(true);
    Post(`agent/visas/set-init/${localStorage.getItem("visaId")}`, {
      ...form, "form": "init_form",
      //
      // dock_id: '1',
      // destination_dock_id:'1',
      ...(!!form.exit_date ?  ({exit_date:moment(form.exit_date).locale('en').format('YYYY-MM-DD').concat(' 00:00:00')}): ({exit_date:null}) ),
      ...(selectedVisa && selectedVisa?.need_exit_dock ? ({}) : ({ destination_dock_id: null, exit_airport: null}))
    })
      .then((res) => {
        forward()
      })
      .catch((error) => {
        toast.error(error.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  console.log({form})
  return (
    <div className={` ${activeStep ? "h-auto" : "h-0 overflow-hidden "}`}>
      <div className={"my-container  bg-white rounded-lg  flex flex-col gap-9 w-full !mt-5  py-10 px-4 md:px-[13%] mb-8"}>
        {
          loading && <LoadingFix />
        }
        <div className={"flex flex-col gap-4 items-stretch"}>
          {selectedVisa && !!selectedVisa?.need_exit_dock &&
            <CustomSelect
              onchange={handleForm}
              options={dockData?.length !== 0 ? dockData : []}
              placeHolder={"DockOfDist"}
              label={"DockOfDist"}
              name={"destination_dock_id"}
            />
          }

          <CustomSelect
            onchange={handleForm}
            options={dockData?.length !== 0 ? dockData : []}
            placeHolder={"dockLocation"}
            label={"dockLocation"}
            name={"dock_id"}
          />

          <CustomSelect
            onchange={handleForm}
            options={data?.ships?.length !== 0 ? data?.ships : []}
            placeHolder={"ship"}
            label={"ship"}
            name={"ship_id"}
          />

          {selectedVisa && !!selectedVisa?.need_exit_dock && <>
            <CustomSelect
              options={dataAirport}
              placeHolder={"ExitAirport"}
              label={"ExitAirport"}
              name={"exit_airport"}
              onchange={handleForm}
            />


            {/* <InputField
              label={t('ExitDate')}
              type='datetime-local'
              onChange={({ target: { value } }) => handleForm({ name: 'exit_date', value })}
              dir='rtl'
              style={{ fontFamily: 'serif !important' }}
              className='en'
            /> */}


            <DatePicker
              value={form['exit_date']}
              onChange={(e) => e ? handleForm({ name: 'exit_date', value:e.toDate() }) : undefined}
              className='border'
              inputClass={clsx('text rounded-lg w-full flex-none border border-gray-300 ')}
              containerClassName='odd'
              calendar={persian}
              format={"YYYY/MM/DD"}
              locale={persian_fa}
              placeholder={t('ExitDate')}


            />

          </>}
        </div>



      </div>

      <div className={"flex justify-between my-container pt-10  items-center"}>
        <div onClick={() => back()} className={"text-main cursor-pointer"}>{t("prevStep")}</div>
        <div className={"min-w-[330px]"}>
          <CustomButton loading={loading} onClick={() => handleSubmit()} title={"saveAndNext"} />
        </div>
      </div>

    </div>
  );
};

export default WharfStep;
